<template>
    <base-dropdown v-else width="w-100">
        <template #trigger>
            <span class="underline dotted cursor-pointer">
                {{ store.name }}
            </span>
        </template>

        <template #content>
            <base-dropdown-link v-for="store in stores" :key="store.id" @click.native="$emit('navigate', store)">
                {{ store.name }}
            </base-dropdown-link>
        </template>
    </base-dropdown>
</template>

<script>
import Store from '@/Models/Store';

export default {
    props: {
        store: {
            type: Store,
            required: true,
        },
    },

    data() {
        return {
            stores: [],
        };
    },

    computed: {
        auth() {
            return auth;
        },
    },

    async created() {
        Store.$all().then(stores => {
            this.stores = stores.filter(store => store.id !== this.store.id);
        });
    },
};
</script>
